export default __webpack_public_path__ + "static/media/ic_payment.bd055139.svg";